import style from './icon.module.css'
export const FactoryIconMenu = () => {
    return(
<svg className={style.icon} viewBox="0 0 203.333 203.333">
<path d="M203.333,104.983v82.451c0,2.761-2.239,5-5,5H5c-2.761,0-5-2.239-5-5v-58.34c0-1.896,1.072-3.628,2.768-4.474l48.333-24.111
	c1.55-0.773,3.39-0.689,4.862,0.222c1.473,0.911,2.37,2.52,2.37,4.252v16.029l29.597-14.764V57.416c0-2.761,2.239-5,5-5h9.074
	c2.761,0,5,2.239,5,5v63.428l33.021-16.472l2.044-88.589c0.063-2.716,2.282-4.885,4.999-4.885h21.797
	c2.716,0,4.936,2.169,4.999,4.885l2.186,94.729l20.051-10.002c1.55-0.773,3.389-0.689,4.862,0.222S203.333,103.251,203.333,104.983z
	 M35.078,151.969H21.553v19.006h13.525V151.969z M71.703,151.969H58.178v19.006h13.525V151.969z M108.329,151.969H94.804v19.006
	h13.525V151.969z M144.955,151.969H131.43v19.006h13.525V151.969z"/>
    </svg>
    )
}